<template>
    <div class="area_section" v-if="state.data != null && state.data.length > 0">
        <div class="area_contents">
            <div class="area_contents_title">
                <p>실인원</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">신규 내담자</th>
                            <th scope="col">실인원</th>
                            <th scope="col">1인당 평균 상담건수</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(998, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(999, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.getCntByCn(999, state.data) === 0
                                        ? 0
                                        : Math.round(CommonUtils.getCntByCn(997, state.data) / CommonUtils.getCntByCn(999, state.data))
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>초기상담유형</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">전화상담</th>
                            <th scope="col">내방상담</th>
                            <th scope="col">방문상담</th>
                            <th scope="col" v-text="state.sYear < 2019 ? '현장상담' : '아웃리치'"></th>
                            <th scope="col">사이버</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(2, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(3, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    state.sYear < 2019
                                        ? CommonUtils.numberFormat(CommonUtils.getCntByCn(4, state.data))
                                        : CommonUtils.numberFormat(CommonUtils.getCntByCn(250, state.data))
                                }}
                            </td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(6, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    state.sYear < 2019
                                        ? CommonUtils.numberFormat(
                                              CommonUtils.getCntByCn(1, state.data) +
                                                  CommonUtils.getCntByCn(2, state.data) +
                                                  CommonUtils.getCntByCn(3, state.data) +
                                                  CommonUtils.getCntByCn(4, state.data) +
                                                  CommonUtils.getCntByCn(6, state.data),
                                          )
                                        : CommonUtils.numberFormat(
                                              CommonUtils.getCntByCn(1, state.data) +
                                                  CommonUtils.getCntByCn(2, state.data) +
                                                  CommonUtils.getCntByCn(3, state.data) +
                                                  CommonUtils.getCntByCn(250, state.data) +
                                                  CommonUtils.getCntByCn(6, state.data),
                                          )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>기관인지경로</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">1366</th>
                            <th scope="col">117</th>
                            <th scope="col">검찰/경찰/법원</th>
                            <!--<th scope="col">언론보도</th>-->
                            <th scope="col">홍보(인터넷,114,언론보도등)</th>
                            <th scope="col">지인소개</th>
                            <th scope="col">유관기관</th>
                            <th scope="col">성매매방지기관</th>
                            <th scope="col">학교</th>
                            <th scope="col">홍보물품</th>
                            <th scope="col">기타</th>
                            <th scope="col">기록없음</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(8, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(9, state.data)) }}</td>
                            <td class="last_line">
                                {{ CommonUtils.numberFormat(CommonUtils.getCntByCn(10, state.data) + CommonUtils.getCntByCn(221, state.data)) }}
                            </td>
                            <!-- 10+221 검찰/경찰/법원-경찰서 -->
                            <!--<td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(11, state.data))}}</td>-->
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(12, state.data) +
                                            CommonUtils.getCntByCn(11, state.data) +
                                            CommonUtils.getCntByCn(222, state.data),
                                    )
                                }}
                            </td>
                            <!--12+11+222 언론보도-홍보(인터넷,114,언론보도등)-홍보(인터넷,114등)-->
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(13, state.data)) }}</td>
                            <td class="last_line">
                                {{ CommonUtils.numberFormat(CommonUtils.getCntByCn(14, state.data) + CommonUtils.getCntByCn(223, state.data)) }}
                            </td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(227, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(228, state.data)) }}</td>
                            <!--학교-->
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(15, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(224, state.data)) }}</td>
                            <td class="last_line">
                                {{ CommonUtils.numberFormat(CommonUtils.getCntByCn(186, state.data) + CommonUtils.getCntByCn(16, state.data)) }}
                            </td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(8, state.data) +
                                            CommonUtils.getCntByCn(9, state.data) +
                                            CommonUtils.getCntByCn(10, state.data) +
                                            CommonUtils.getCntByCn(221, state.data) +
                                            CommonUtils.getCntByCn(11, state.data) +
                                            CommonUtils.getCntByCn(12, state.data) +
                                            CommonUtils.getCntByCn(222, state.data) +
                                            CommonUtils.getCntByCn(13, state.data) +
                                            CommonUtils.getCntByCn(14, state.data) +
                                            CommonUtils.getCntByCn(223, state.data) +
                                            CommonUtils.getCntByCn(227, state.data) +
                                            CommonUtils.getCntByCn(228, state.data) +
                                            CommonUtils.getCntByCn(15, state.data) +
                                            CommonUtils.getCntByCn(224, state.data) +
                                            CommonUtils.getCntByCn(186, state.data) +
                                            CommonUtils.getCntByCn(16, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>상담의뢰인</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">본인</th>
                            <th scope="col">가족친인척</th>
                            <th scope="col">동료/이웃</th>
                            <th scope="col">타기관</th>
                            <th scope="col">유관기관</th>
                            <th scope="col">기록없음</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(164, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(165, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(166, state.data) +
                                            CommonUtils.getCntByCn(238, state.data) +
                                            CommonUtils.getCntByCn(239, state.data),
                                    )
                                }}
                            </td>
                            <!--동료/이웃-동료-이웃-->
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(167, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(237, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(225, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(164, state.data) +
                                            CommonUtils.getCntByCn(165, state.data) +
                                            CommonUtils.getCntByCn(166, state.data) +
                                            CommonUtils.getCntByCn(238, state.data) +
                                            CommonUtils.getCntByCn(239, state.data) +
                                            CommonUtils.getCntByCn(167, state.data) +
                                            CommonUtils.getCntByCn(237, state.data) +
                                            CommonUtils.getCntByCn(225, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>나이</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">13세이하</th>
                            <th scope="col">14~16세</th>
                            <th scope="col">17~19세</th>
                            <th scope="col">20~29세</th>
                            <th scope="col">30~39세</th>
                            <th scope="col">40~49세</th>
                            <th scope="col">50~59세</th>
                            <th scope="col">60세이상</th>
                            <th scope="col">기록없음</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(240, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(241, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(242, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(243, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(244, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(245, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(246, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(247, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(248, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(240, state.data) +
                                            CommonUtils.getCntByCn(241, state.data) +
                                            CommonUtils.getCntByCn(242, state.data) +
                                            CommonUtils.getCntByCn(243, state.data) +
                                            CommonUtils.getCntByCn(244, state.data) +
                                            CommonUtils.getCntByCn(245, state.data) +
                                            CommonUtils.getCntByCn(246, state.data) +
                                            CommonUtils.getCntByCn(247, state.data) +
                                            CommonUtils.getCntByCn(248, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>만나이</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">
                                13세이하
                                <br />
                                (만 12세 이하)
                            </th>
                            <th scope="col">
                                14~16세
                                <br />
                                (만 13~15세)
                            </th>
                            <th scope="col">
                                17~19세
                                <br />
                                (만 16~18세)
                            </th>
                            <th scope="col">
                                20~29세
                                <br />
                                (만 19~28세)
                            </th>
                            <th scope="col">
                                30~39세
                                <br />
                                (만 29~38세)
                            </th>
                            <th scope="col">
                                40~49세
                                <br />
                                (만 39~38세)
                            </th>
                            <th scope="col">
                                50~59세
                                <br />
                                (만 49~58세)
                            </th>
                            <th scope="col">
                                60세이상
                                <br />
                                (만 59세 이상)
                            </th>
                            <th scope="col">기록없음</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(280, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(281, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(282, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(283, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(284, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(285, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(286, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(287, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(288, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(280, state.data) +
                                            CommonUtils.getCntByCn(281, state.data) +
                                            CommonUtils.getCntByCn(282, state.data) +
                                            CommonUtils.getCntByCn(283, state.data) +
                                            CommonUtils.getCntByCn(284, state.data) +
                                            CommonUtils.getCntByCn(285, state.data) +
                                            CommonUtils.getCntByCn(286, state.data) +
                                            CommonUtils.getCntByCn(287, state.data) +
                                            CommonUtils.getCntByCn(288, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>학력</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">없음</th>
                            <th scope="col">초교중퇴</th>
                            <th scope="col">초교졸</th>
                            <th scope="col">중재</th>
                            <th scope="col">중교중퇴</th>
                            <th scope="col">중교졸</th>
                            <th scope="col">고재</th>
                            <th scope="col">고교중퇴</th>
                            <th scope="col">고교졸</th>
                            <th scope="col">대중퇴</th>
                            <th scope="col">대재</th>
                            <th scope="col">대졸</th>
                            <th scope="col">대학원재</th>
                            <th scope="col">대학원졸</th>
                            <th scope="col">기타</th>
                            <th scope="col">기록없음</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(57, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(58, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(59, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(210, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(60, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(61, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(211, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(62, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(63, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(64, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(65, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(66, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(67, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(68, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(69, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(70, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(57, state.data) +
                                            CommonUtils.getCntByCn(58, state.data) +
                                            CommonUtils.getCntByCn(59, state.data) +
                                            CommonUtils.getCntByCn(210, state.data) +
                                            CommonUtils.getCntByCn(60, state.data) +
                                            CommonUtils.getCntByCn(61, state.data) +
                                            CommonUtils.getCntByCn(211, state.data) +
                                            CommonUtils.getCntByCn(62, state.data) +
                                            CommonUtils.getCntByCn(63, state.data) +
                                            CommonUtils.getCntByCn(64, state.data) +
                                            CommonUtils.getCntByCn(65, state.data) +
                                            CommonUtils.getCntByCn(66, state.data) +
                                            CommonUtils.getCntByCn(67, state.data) +
                                            CommonUtils.getCntByCn(68, state.data) +
                                            CommonUtils.getCntByCn(69, state.data) +
                                            CommonUtils.getCntByCn(70, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>혼인여부</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">미혼</th>
                            <th scope="col">동거</th>
                            <th scope="col">이혼</th>
                            <th scope="col">혼인 중</th>
                            <th scope="col">기타</th>
                            <th scope="col">기록없음</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(91, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(92, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(93, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(94, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(95, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(96, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(91, state.data) +
                                            CommonUtils.getCntByCn(92, state.data) +
                                            CommonUtils.getCntByCn(93, state.data) +
                                            CommonUtils.getCntByCn(94, state.data) +
                                            CommonUtils.getCntByCn(95, state.data) +
                                            CommonUtils.getCntByCn(96, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>가족관계</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">보호자 있음</th>
                            <th scope="col">보호자 없음</th>
                            <th scope="col">기록없음</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(97, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(98, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(99, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(97, state.data) +
                                            CommonUtils.getCntByCn(98, state.data) +
                                            CommonUtils.getCntByCn(99, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>자녀여부</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">자녀 없음</th>
                            <th scope="col">자녀 1인</th>
                            <th scope="col">자녀 2인</th>
                            <th scope="col">자녀 3인</th>
                            <th scope="col">자녀 4인 이상</th>
                            <th scope="col">기록없음</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(100, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(101, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(102, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(103, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(104, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(105, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(100, state.data) +
                                            CommonUtils.getCntByCn(101, state.data) +
                                            CommonUtils.getCntByCn(102, state.data) +
                                            CommonUtils.getCntByCn(103, state.data) +
                                            CommonUtils.getCntByCn(104, state.data) +
                                            CommonUtils.getCntByCn(105, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>성매매유형</p>
            </div>

            <div class="area_contents_body">
                <template v-if="state.sYear >= 2019">
                    <table class="areaGrid">
                        <thead>
                            <tr>
                                <th scope="col">
                                    (전업형)
                                    <br />
                                    집결지
                                </th>
                                <th scope="col">
                                    (전업형)
                                    <br />
                                    오피스텔
                                </th>
                                <th scope="col">
                                    겸업형
                                    <br />
                                    (기존산업형)
                                </th>
                                <th scope="col">
                                    위장형
                                    <br />
                                    (기존산업형)
                                </th>
                                <th scope="col">출장형</th>
                                <th scope="col">온라인</th>
                                <th scope="col">해외성매매</th>
                                <th scope="col">기타</th>
                                <th scope="col">
                                    기록
                                    <br />
                                    없음
                                </th>
                                <th scope="col" id="last_th">총합</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(106, state.data)) }}</td>
                                <td class="last_line">
                                    {{ CommonUtils.numberFormat(CommonUtils.getCntByCn(251, state.data) + CommonUtils.getCntByCn(230, state.data)) }}
                                </td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(252, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(253, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(254, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(255, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(234, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(195, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(113, state.data)) }}</td>
                                <td class="last_line">
                                    {{
                                        CommonUtils.numberFormat(
                                            CommonUtils.getCntByCn(106, state.data) +
                                                CommonUtils.getCntByCn(251, state.data) +
                                                CommonUtils.getCntByCn(230, state.data) +
                                                CommonUtils.getCntByCn(252, state.data) +
                                                CommonUtils.getCntByCn(253, state.data) +
                                                CommonUtils.getCntByCn(254, state.data) +
                                                CommonUtils.getCntByCn(255, state.data) +
                                                CommonUtils.getCntByCn(234, state.data) +
                                                CommonUtils.getCntByCn(195, state.data) +
                                                CommonUtils.getCntByCn(113, state.data),
                                        )
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </template>
                <template v-else>
                    <table class="areaGrid">
                        <thead>
                            <tr>
                                <th scope="col">집결지</th>
                                <th scope="col">
                                    오피스텔
                                    <br />
                                    성매매
                                </th>
                                <th scope="col">식품접객업소</th>
                                <th scope="col">위생접객업소</th>
                                <th scope="col">마사지업소</th>
                                <th scope="col">풍속영업업소</th>
                                <th scope="col">
                                    변종
                                    <br />
                                    성매매
                                </th>
                                <th scope="col">
                                    전자형성매매
                                    <br />
                                    (조건만남)-개인
                                </th>
                                <th scope="col">
                                    전자형성매매
                                    <br />
                                    (조건만남)-알선
                                </th>
                                <th scope="col">
                                    길거리
                                    <br />
                                    성매매
                                </th>
                                <th scope="col">
                                    출장형
                                    <br />
                                    성매매
                                </th>
                                <th scope="col">외국인전용클럽</th>
                                <th scope="col">
                                    해외
                                    <br />
                                    성매매
                                </th>
                                <th scope="col">기타</th>
                                <th scope="col">
                                    기록
                                    <br />
                                    없음
                                </th>
                                <th scope="col" id="last_th">총합</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(106, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(230, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(107, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(108, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(109, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(192, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(193, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(231, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(232, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(233, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(111, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(110, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(234, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(195, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(113, state.data)) }}</td>
                                <td class="last_line">
                                    {{
                                        CommonUtils.numberFormat(
                                            CommonUtils.getCntByCn(106, state.data) +
                                                CommonUtils.getCntByCn(230, state.data) +
                                                CommonUtils.getCntByCn(107, state.data) +
                                                CommonUtils.getCntByCn(108, state.data) +
                                                CommonUtils.getCntByCn(109, state.data) +
                                                CommonUtils.getCntByCn(192, state.data) +
                                                CommonUtils.getCntByCn(193, state.data) +
                                                CommonUtils.getCntByCn(231, state.data) +
                                                CommonUtils.getCntByCn(232, state.data) +
                                                CommonUtils.getCntByCn(233, state.data) +
                                                CommonUtils.getCntByCn(111, state.data) +
                                                CommonUtils.getCntByCn(110, state.data) +
                                                CommonUtils.getCntByCn(234, state.data) +
                                                CommonUtils.getCntByCn(195, state.data) +
                                                CommonUtils.getCntByCn(113, state.data),
                                        )
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </template>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>성매매지역</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">강남</th>
                            <th scope="col">강동</th>
                            <th scope="col">강북</th>
                            <th scope="col">강서</th>
                            <th scope="col">관악</th>
                            <th scope="col">광진</th>
                            <th scope="col">구로</th>
                            <th scope="col">금천</th>
                            <th scope="col">노원</th>
                            <th scope="col">도봉</th>
                            <th scope="col">동대문</th>
                            <th scope="col">동작</th>
                            <th scope="col">마포</th>
                            <th scope="col">서대문</th>
                            <th scope="col">서초</th>
                            <th scope="col">성동</th>
                            <th scope="col">성북</th>
                            <th scope="col">송파</th>
                            <th scope="col">양천</th>
                            <th scope="col">영등포</th>
                            <th scope="col">용산</th>
                            <th scope="col">은평</th>
                            <th scope="col">종로</th>
                            <th scope="col">중구</th>
                            <th scope="col" id="last_th">중랑</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(116, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(117, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(118, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(119, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(120, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(121, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(122, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(123, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(124, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(125, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(126, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(127, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(128, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(129, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(130, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(131, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(132, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(133, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(134, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(135, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(136, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(137, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(138, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(168, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(169, state.data)) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">광주광역시</th>
                            <th scope="col">대구광역시</th>
                            <th scope="col">대전광역시</th>
                            <th scope="col">부산광역시</th>
                            <th scope="col">울산광역시</th>
                            <th scope="col">인천광역시</th>
                            <th scope="col">강원도</th>
                            <th scope="col">경기도</th>
                            <th scope="col">경상남도</th>
                            <th scope="col">경상북도</th>
                            <th scope="col">전라남도</th>
                            <th scope="col">전라북도</th>
                            <th scope="col">제주도</th>
                            <th scope="col">충청남도</th>
                            <th scope="col">충청북도</th>
                            <th scope="col">외국</th>
                            <th scope="col">인터넷</th>
                            <th scope="col">기록없음</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(170, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(171, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(172, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(173, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(174, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(175, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(176, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(177, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(178, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(179, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(180, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(181, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(182, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(183, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(184, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(115, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(190, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(185, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(115, state.data) +
                                            CommonUtils.getCntByCn(116, state.data) +
                                            CommonUtils.getCntByCn(117, state.data) +
                                            CommonUtils.getCntByCn(118, state.data) +
                                            CommonUtils.getCntByCn(119, state.data) +
                                            CommonUtils.getCntByCn(120, state.data) +
                                            CommonUtils.getCntByCn(121, state.data) +
                                            CommonUtils.getCntByCn(122, state.data) +
                                            CommonUtils.getCntByCn(123, state.data) +
                                            CommonUtils.getCntByCn(124, state.data) +
                                            CommonUtils.getCntByCn(125, state.data) +
                                            CommonUtils.getCntByCn(126, state.data) +
                                            CommonUtils.getCntByCn(127, state.data) +
                                            CommonUtils.getCntByCn(128, state.data) +
                                            CommonUtils.getCntByCn(129, state.data) +
                                            CommonUtils.getCntByCn(130, state.data) +
                                            CommonUtils.getCntByCn(131, state.data) +
                                            CommonUtils.getCntByCn(132, state.data) +
                                            CommonUtils.getCntByCn(133, state.data) +
                                            CommonUtils.getCntByCn(134, state.data) +
                                            CommonUtils.getCntByCn(135, state.data) +
                                            CommonUtils.getCntByCn(136, state.data) +
                                            CommonUtils.getCntByCn(137, state.data) +
                                            CommonUtils.getCntByCn(138, state.data) +
                                            CommonUtils.getCntByCn(168, state.data) +
                                            CommonUtils.getCntByCn(169, state.data) +
                                            CommonUtils.getCntByCn(170, state.data) +
                                            CommonUtils.getCntByCn(171, state.data) +
                                            CommonUtils.getCntByCn(172, state.data) +
                                            CommonUtils.getCntByCn(173, state.data) +
                                            CommonUtils.getCntByCn(174, state.data) +
                                            CommonUtils.getCntByCn(175, state.data) +
                                            CommonUtils.getCntByCn(176, state.data) +
                                            CommonUtils.getCntByCn(177, state.data) +
                                            CommonUtils.getCntByCn(178, state.data) +
                                            CommonUtils.getCntByCn(179, state.data) +
                                            CommonUtils.getCntByCn(180, state.data) +
                                            CommonUtils.getCntByCn(181, state.data) +
                                            CommonUtils.getCntByCn(182, state.data) +
                                            CommonUtils.getCntByCn(183, state.data) +
                                            CommonUtils.getCntByCn(184, state.data) +
                                            CommonUtils.getCntByCn(185, state.data) +
                                            CommonUtils.getCntByCn(190, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents" v-if="state.sYear < 2019">
            <div class="area_contents_title">
                <p>종사시간</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">1개월미만</th>
                            <th scope="col">1개월이상~6개월미만</th>
                            <th scope="col">6개월이상~1년미만</th>
                            <th scope="col">1년</th>
                            <th scope="col">2년</th>
                            <th scope="col">3년</th>
                            <th scope="col">4년</th>
                            <th scope="col">5년</th>
                            <th scope="col">6년</th>
                            <th scope="col">7년</th>
                            <th scope="col">8년</th>
                            <th scope="col">9년</th>
                            <th scope="col">10년</th>
                            <th scope="col">10년이상</th>
                            <th scope="col">기록없음</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(196, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(197, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(198, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(199, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(200, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(201, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(202, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(203, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(204, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(205, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(206, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(207, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(208, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(209, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(236, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(196, state.data) +
                                            CommonUtils.getCntByCn(197, state.data) +
                                            CommonUtils.getCntByCn(198, state.data) +
                                            CommonUtils.getCntByCn(199, state.data) +
                                            CommonUtils.getCntByCn(200, state.data) +
                                            CommonUtils.getCntByCn(201, state.data) +
                                            CommonUtils.getCntByCn(202, state.data) +
                                            CommonUtils.getCntByCn(203, state.data) +
                                            CommonUtils.getCntByCn(204, state.data) +
                                            CommonUtils.getCntByCn(205, state.data) +
                                            CommonUtils.getCntByCn(206, state.data) +
                                            CommonUtils.getCntByCn(207, state.data) +
                                            CommonUtils.getCntByCn(208, state.data) +
                                            CommonUtils.getCntByCn(209, state.data) +
                                            CommonUtils.getCntByCn(236, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>선불액수</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">300만원미만</th>
                            <th scope="col">300~700만원미만</th>
                            <th scope="col">700~1,000만원미만</th>
                            <th scope="col">1,000~2,000만원미만</th>
                            <th scope="col">2,000~5,000만원미만</th>
                            <th scope="col">5,000~1억원미만</th>
                            <th scope="col">1억원 미만</th>
                            <th scope="col">그외 채무</th>
                            <th scope="col">없음</th>
                            <th scope="col">기록없음</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(187, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(150, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(151, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(152, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(153, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(154, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(155, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(189, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(188, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(156, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(187, state.data) +
                                            CommonUtils.getCntByCn(150, state.data) +
                                            CommonUtils.getCntByCn(151, state.data) +
                                            CommonUtils.getCntByCn(152, state.data) +
                                            CommonUtils.getCntByCn(153, state.data) +
                                            CommonUtils.getCntByCn(154, state.data) +
                                            CommonUtils.getCntByCn(155, state.data) +
                                            CommonUtils.getCntByCn(156, state.data) +
                                            CommonUtils.getCntByCn(188, state.data) +
                                            CommonUtils.getCntByCn(189, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>가출경험유무</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">있음</th>
                            <th scope="col">없음</th>
                            <th scope="col">기록없음</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(215, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(216, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(217, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(215, state.data) +
                                            CommonUtils.getCntByCn(216, state.data) +
                                            CommonUtils.getCntByCn(217, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>성폭력유무</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">있음</th>
                            <th scope="col">없음</th>
                            <th scope="col">기록없음</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(218, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(219, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(220, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(218, state.data) +
                                            CommonUtils.getCntByCn(219, state.data) +
                                            CommonUtils.getCntByCn(220, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>가정폭력유무</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">있음</th>
                            <th scope="col">없음</th>
                            <th scope="col">기록없음</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(212, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(213, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(214, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(212, state.data) +
                                            CommonUtils.getCntByCn(213, state.data) +
                                            CommonUtils.getCntByCn(214, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>알선고리</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">보도방</th>
                            <th scope="col">소개업자</th>
                            <th scope="col">사채업자</th>
                            <th scope="col">업주</th>
                            <th scope="col">업소관계자</th>
                            <th scope="col">친구,지인</th>
                            <th scope="col">보호자,가족</th>
                            <th scope="col">홍보물</th>
                            <th scope="col">구인구직사이트</th>
                            <th scope="col">채팅앱</th>
                            <th scope="col">기타</th>
                            <th scope="col">기록없음</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(260, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(261, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(262, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(263, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(264, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(265, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(266, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(267, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(268, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(269, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(270, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(271, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(260, state.data) +
                                            CommonUtils.getCntByCn(261, state.data) +
                                            CommonUtils.getCntByCn(262, state.data) +
                                            CommonUtils.getCntByCn(263, state.data) +
                                            CommonUtils.getCntByCn(264, state.data) +
                                            CommonUtils.getCntByCn(265, state.data) +
                                            CommonUtils.getCntByCn(266, state.data) +
                                            CommonUtils.getCntByCn(267, state.data) +
                                            CommonUtils.getCntByCn(268, state.data) +
                                            CommonUtils.getCntByCn(269, state.data) +
                                            CommonUtils.getCntByCn(270, state.data) +
                                            CommonUtils.getCntByCn(271, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>상담유형</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th>전화상담</th>
                            <th>내방상담</th>
                            <th>방문상담</th>
                            <th>사이버</th>
                            <th>서신</th>
                            <th>아웃리치</th>
                            <th>온라인 상담</th>
                            <th>총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                {{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1, state.data) - CommonUtils.getCntByCn(56, state.data)) }}
                            </td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(2, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(3, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(5, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(95, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(6, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(620, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(1, state.data) -
                                            CommonUtils.getCntByCn(56, state.data) +
                                            CommonUtils.getCntByCn(2, state.data) +
                                            CommonUtils.getCntByCn(3, state.data) +
                                            CommonUtils.getCntByCn(5, state.data) +
                                            CommonUtils.getCntByCn(95, state.data) +
                                            CommonUtils.getCntByCn(6, state.data) +
                                            CommonUtils.getCntByCn(620, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="area_section" v-else></div>
</template>

<script lang="ts" config>
    import { DataGrid, reactive, onMounted, Header, Left, ModalDefault, types, PageBtn, CommonUtils, watch } from "@/BaseComponent";

    export default {
        props: { data: { type: Array<types.statistics.StatisticsVOForApi>, default: [] }, sYear: { type: Number, default: 0 } },
        components: { Header, Left, ModalDefault, PageBtn, DataGrid },
        setup(props: any) {
            const state = reactive({
                data: [] as Array<types.statistics.StatisticsVOForApi>,
                sYear: 0 as number,
            });

            onMounted(() => {
                if (props.data) state.data = props.data;
                if (props.sYear && props.sYear > 0) state.sYear = props.sYear;
            });

            watch(props, () => {
                if (props.data) state.data = props.data;
                if (props.sYear && props.sYear > 0) state.sYear = props.sYear;
            });

            return {
                state,
                CommonUtils,
            };
        },
    };
</script>
<style scoped>
    .areaGrid td {
        text-align: center;
    }
</style>
